import { Search } from '@/components/Elements/Filter';

import { Filters } from './Filters';
import { Table } from './Table';

export const WorkersTable = () => {
  return (
    <>
      <Search />
      <Filters />
      <Table />
    </>
  );
};
